import { Navigate, Outlet } from 'react-router';

import { useAuth } from './useAuth';
import { INVENTORY_FALLBACK_ROUTE, isInventoryInCarculate } from './inventory';

/**
 * EPIC-022 S022.1 (AC 19) — de route-guard van Inkoop → Voorraad (`/inkoop/voorraad…`). Zonder voorraad in CARculate
 * (whoami `inventoryInCarculate !== true`) gaat een direct ingetypt adres terug naar de bestellijst. Een menu-hint, geen
 * slot: de autoriteit is de poort van `api/inventory/warehouses` (403/503, die het scherm zelf toont).
 *
 * Statisch in `routes.tsx` (net als de andere guards): hij beslist vóór het scherm geladen wordt.
 */
export function InventoryRouteGuard() {
    const { user, isLoading } = useAuth();
    if (isLoading) return null;
    if (!isInventoryInCarculate(user)) return <Navigate to={INVENTORY_FALLBACK_ROUTE} replace />;
    return <Outlet />;
}
